<script>
/**
 * 最終処分終了報告
 * 処理フロー
 */
export default {
  name: "RecycleFinalDisposalFlowInformation",
  components: {},
  props: {

    /**
     * マニフェスト
     */
    manifest: {
      type: Object,
      default: () => ({}),
    },

    /**
     * 最初の行かどうか（複写ボタンの表示で利用する）
      * @type {Boolean}
     */
    isFirstField: {
      type: Boolean,
      default: () => false,
    },
    /**
     *
     * single: 単体登録画面から呼び出されたかどうか
     * bulk: 一括登録画面から呼び出されたかどうか
     */
    callerType: {
      type: String,
      default: () => null,
    },
  },

  data() {
    return {
      headers: [],
      patternId: null,
      patternType: null,
      patterns: [],
    }
  },
  watch: {
    "manifest.pattern": {
      handler (newValue, oldValue) {
        if (!newValue) {
          this.patternId = null;
          return
        }
        this.patternId = newValue.id;
        this.patternType = newValue.type;
      },
      immediate: true,
      deep: true,
    }
  },
  computed: {
    flowRules () {

      if (!this.manifest.target_for_registration) {
        return null;
      }
      let rules = {
        pMLength: { targetList: this.manifest.manifest_recycle_disposal_reports },
        pMOnlyFirstLayer: { targetList: this.manifest.manifest_recycle_disposal_reports },
      }
      if (this.callerType === "bulk") {
        rules['pmFirstBeforeRatioTotal'] = { targetList: this.manifest.manifest_recycle_disposal_reports }
      } else {
        rules['pmFirstBeforeWeightTotalRange'] = {targetList: this.manifest.manifest_recycle_disposal_reports, final_disposal_quantity: this.manifest.final_disposal_quantity }
      }
      return rules;
    },
  },
  created() {

    if (this.callerType === "bulk") {
      this.headers = [
        { value: "level", text: "", width: "5%" },
        { value: "disposer", text: "処分業者\r\n処分事業場\r\n住所", width: "12%" },
        { value: "before_disposal_ratio", text: "処分前重量", width: "9%" },
        { value: "disposal_method", text: "処分方法", width: "11%" },
        { value: "after_disposal_ratio", text: "処理後重量", width: "9%" },
        { value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "10%" },
        { value: "final_disposal", text: "最終処分", width: "10%" },
        { value: "add_next_step", text: "後工程", width: "12%", align: "center" },
        { value: "input_final_disposal_date", text: "最終処分終了日", width: "10%" },
        { value: "comment", text: "備考", width: "11%", editable: true },
        { value: "edit_request_action", text: "", width: "3%", align: "end" },
      ]

    } else {
      this.headers = [
        { value: "level", text: "", width: "5%" },
        { value: "disposer", text: "処分業者\r\n処分事業場\r\n住所", width: "12%" },
        { value: "report_before_disposal_weight", text: "処分前重量", width: "9%" },
        { value: "disposal_method", text: "処分方法", width: "11%" },
        { value: "report_after_disposal_weight", text: "処理後重量", width: "9%" },
        { value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "10%" },
        { value: "final_disposal", text: "最終処分", width: "8%" },
        { value: "add_next_step", text: "後工程", width: "13%", align: "center" },
        { value: "input_final_disposal_date", text: "最終処分終了日", width: "12%" },
        { value: "comment", text: "備考", width: "11%", editable: true },
        { value: "edit_request_action", text: "", width: "3%", align: "end" },
      ]

    }

  },
  methods: {
    /**
     * 再資源化等パターン変更 コールバック
     * リストの洗い替えを行う.
     * @param values { Array }
     */
    replaceResultList (values) {

      // 01工程で最終の場合は、中間で登録した処分終了日をセット
      values.forEach(value => {
        if (value.level === 1 && value.final_disposal) {
          value.final_disposal_date = this.manifest.disposal_report_end_date
        }
      });

      this.manifest.manifest_recycle_disposal_reports = values;
    },

  },
}
</script>

<template>
  <div class="reportLayer">
    <!-- 処理フロー -->
    <validation-provider
      v-slot="{ errors: detailErrors }"
      :vid="`manifest_recycle_disposal_reports-${manifest.id}`"
      :rules="flowRules"
      name="リスト"
    >
      <div class="hidden">
        <v-input
          v-model="manifest"
          :error-messages="detailErrors"
          dense
          outlined
          readonly
          hide-details="auto"
        >
          <template v-slot:message>
            <div class="ml-2">
              <p v-for="(message, index) in detailErrors" :key="index">{{ message }}</p>
            </div>
          </template>
        </v-input>
      </div>

      <recycle-step-table
        :headers="headers"
        :final-disposal-minimum-date="manifest.collected_date"
        :result-list.sync="manifest.manifest_recycle_disposal_reports"
        :target-for-registration="manifest.target_for_registration"
        :has-error="detailErrors.length > 0"
        :final-disposal-quantity.sync="manifest.final_disposal_quantity"
        :pattern-id="patternId"
        :pattern-type="patternType"
        call-source="finalDisposal"
        @replace:list="replaceResultList"
      />
    </validation-provider>

    <!-- 処理フロー -->
  </div>
</template>
